import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from '@fareye/utils'
import { Flex, Span, Label } from '@fareye/ui'
import { SummaryFilterContainer } from '../../style/styled'
import { KPI_COLORS } from '../../config/constants'

export const SummaryFilter = ({ summaryList }: any) => {
  const { t } = useTranslation()
  return !isEmpty(summaryList) ? (
    <SummaryFilterContainer data-testid="summary">
      {summaryList.map((item: any, i: number) => (
        <Flex column m={2} key={item.label} data-testid={`summary-item-${i}`}>
          <Label
            color={(KPI_COLORS as any)[item.label]}
            style={{ textAlign: 'center', fontSize: '18px' }}
          >
            {t(item.value)}
          </Label>
          <Span variant="secondary" style={{ textAlign: 'center' }}>
            {t(item.label)}
          </Span>
        </Flex>
      ))}
    </SummaryFilterContainer>
  ) : null
}
